<template>
    <div class="home-container">
      <div class="d-flex flex-column align-items-center justify-content-center gap-3">
        <h5 v-if="!createdUserData.username" class="extra-large-text">დაამატეთ თანამშრომელი</h5>
        <div v-if="createdUserData.username" class="created-use-board border-radius-10 d-flex flex-column align-items-center gap-3 common-box-shadow">
            <p class="extra-large-text">დამატებული თანამშრომლის ინფორმაცია</p>
            <p class="large-text extra-red-color">გთხოვთ შეინახოთ მოცემული ინფორმაცია გვერდის თავიდან ჩატვირთვამდე</p>
            <div class="w-100 d-flex flex-column align-items-center gap-2"> 
                <p class="large-text">email: {{ createdUserData.username }}</p>
                <p class="large-text">password: {{ createdUserData.password }}</p>
            </div>
            <primaryButtonComponent @click="refreshPage" buttonType="button" class="large-text font-weight-600" buttonWidth="max-content">
                <template v-slot:content>
                    <p>გვერდის თავიდან ჩატვირთვა</p>
                </template>
            </primaryButtonComponent>
        </div>
        <form v-else class="add-organization-form modal-form-grid-wrapper p-4 border-radius-10" @submit.prevent="addUsers">
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="name" class="ms-2">სახელი(ქართულად)</label>
            <input v-model="userDataVModels.name" type="text" autocomplete="off" name="name" id="name" required placeholder="სახელი(ქართულად)" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="nameeng" class="ms-2">(ინგლისურად)სახელი</label>
            <input v-model="userDataVModels.nameeng" type="text" autocomplete="off" name="nameeng" id="nameeng" required placeholder="(ინგლისურად)სახელი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="surname" class="ms-2">გვარი(ქართულად)</label>
            <input v-model="userDataVModels.surename" type="text" autocomplete="off" name="surname" id="surname" required placeholder="გვარი(ქართულად)" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="surnameeng" class="ms-2">(ინგლისურად)გვარი</label>
            <input v-model="userDataVModels.surenameeng" type="text" autocomplete="off" name="surnameeng" id="surnameeng" required placeholder="(ინგლისურად)გვარი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="privateNumber" class="ms-2">პირადი ნომერი</label>
            <input v-model="userDataVModels.personal_number" type="text" autocomplete="off" name="privateNumber" id="privateNumber" required placeholder="პირადი ნომერი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="email" class="ms-2">email</label>
            <input v-model="userDataVModels.email" type="email" autocomplete="off" name="email" id="email" required placeholder="email" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="address" class="ms-2">მისამართი</label>
            <input v-model="userDataVModels.address" type="text" autocomplete="off" name="address" id="address" required placeholder="მისამართი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="phone" class="ms-2">ტელეფონის ნომერი</label>
            <input v-model="userDataVModels.phone" type="text" autocomplete="off" name="phone" id="phone" required placeholder="ტელეფონის ნომერი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="bdate" class="ms-2">დაბადების თარიღი</label>
            <input v-model="userDataVModels.bdate" type="date" autocomplete="off" name="bdate" id="bdate" required placeholder="დაბადების თარიღი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="genderID" id="genderID-assist" class="ms-2">სქესი</label>
            <Multiselect v-for="(data, i) of genderMultiselectArray" name="genderID" id="genderID" v-model="userDataVModels.genderID" :options="data.options" :mode="data.mode"
                :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="true"
                class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
          </fieldset>
          <fieldset class="multiselects-wrapper d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <linearSearchingMultiSearch :multiselectArray="officePositionMultiselectArray" @finalResult="getFinalPositionOfficeResult"/>
          </fieldset>
          <fieldset class="multiselects-wrapper d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <linearSearchingMultiSearch :multiselectArray="districtIDMultiselectArray" @finalResult="getFinalPositionOfficeResult"/>
          </fieldset>
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="employeePhoto" class="ms-2">თანამშრომლის სურათი</label>
            <input ref="employeePhoto" type="file" accept="image/jpeg" autocomplete="off" name="employeePhoto" id="employeePhoto" required placeholder="აირჩიეთ სურათი ლოგოსთვის" class="blue-part-input large-text">
          </fieldset>
          <div class="button-wrapper d-flex justify-content-center w-100">
            <secondaryButton :disabled="isSending" buttonWidth="max-content" buttonType="submit" class="large-text mt-4">
                <template v-slot:content>
                    დამატება
                </template>
            </secondaryButton>
          </div>
        </form>
      </div>
    </div>
</template>
<script>
import secondaryButton from "@/components/secondaryButton.vue"
import Multiselect from "@vueform/multiselect/src/Multiselect";
import linearSearchingMultiSearch from "@/components/linearSearchingMultiSearch.vue";
import primaryButtonComponent from "@/components/primaryButtonComponent.vue";
export default {
  data(){
    return {
      isSending: false,
        createdUserData: {
            username: null,
            password: null,
        },
      userDataVModels: {
        name: "",
        nameeng: "",
        surename: "",
        surenameeng: "",
        personal_number: "",
        email: "",
        bdate: "",
        address: "",
        phone: "",
        genderID: null,
        officeID: null,
        positionID: null,
        districtID: null,
        photo: null,
      },
      genderMultiselectArray: [
        {
          placeholder: "სქესი",
          options: [],
          Vmodel: null,
          mode: "single",
          isDisabled: false,
        },
      ],
      officePositionMultiselectArray: [
        {
          placeholder: "ოფისი",
          getterEndpoint: "getOffices",
          options: [],
          Vmodel: null,
          sendName: "officeID",
          mode: "single",
          isDisabled: false,
          dependancyArray: [],
          previousMultiselectId: null,
          valueName: "officeID",
          georgianLabel: "office_name",
          englishLabel: "office_nameeng",
          locale: "ge",
        },
        {
          placeholder: "პოზიცია",
          getterEndpoint: "getPositions",
          options: [],
          Vmodel: null,
          sendName: "positionID",
          mode: "single",
          isDisabled: true,
          dependancyArray: [],
          previousMultiselectId: null,
          valueName: "positionID",
          georgianLabel: "position",
          englishLabel: "positioneng",
          locale: "ge",
        },
      ],
      districtIDMultiselectArray: [
        {
          placeholder: "მუნიციპალიტეტი",
          getterEndpoint: "getMunicipalities",
          options: [],
          Vmodel: null,
          sendName: null,
          mode: "single",
          isDisabled: false,
          dependancyArray: [],
          previousMultiselectId: null,
          valueName: "municipalityID",
          georgianLabel: "municipality",
          englishLabel: "municipalityeng",
          locale: "ge",
        },
        {
          placeholder: "ქალაქი",
          getterEndpoint: "getCities",
          options: [],
          Vmodel: null,
          sendName: null,
          mode: "single",
          isDisabled: true,
          dependancyArray: [],
          previousMultiselectId: null,
          valueName: "cityID",
          georgianLabel: "city",
          englishLabel: "cityeng",
          locale: "ge",
        },
        {
          placeholder: "რაიონი",
          getterEndpoint: "getRegions",
          options: [],
          Vmodel: null,
          sendName: null,
          mode: "single",
          isDisabled: true,
          dependancyArray: [],
          previousMultiselectId: null,
          valueName: "regionID",
          georgianLabel: "region",
          englishLabel: "regioneng",
          locale: "ge",
        },
        {
          placeholder: "უბანი",
          getterEndpoint: "getDistricts",
          options: [],
          Vmodel: null,
          sendName: "districtID",
          mode: "single",
          isDisabled: true,
          dependancyArray: [],
          previousMultiselectId: null,
          valueName: "districtID",
          georgianLabel: "district",
          englishLabel: "districteng",
          locale: "ge",
        }
      ],
    }
  },
  components: {
    secondaryButton,
    Multiselect,
    linearSearchingMultiSearch,
    primaryButtonComponent,
  },
  mounted(){
    this.getGenders();
  },
  methods: {
    refreshPage(){
        this.$router.go();
    },
    getFinalPositionOfficeResult(finalResultObj){
        this.userDataVModels[finalResultObj.sendName] = finalResultObj.value;
    },
    getGenders(){
        this.$store.dispatch("getGenders").then((response) => {
            let tempArray = [];
            for(let gender of response.data){
                tempArray.push({
                    value: gender.genderID,
                    label: {
                        ge: gender.gender,
                        en: gender.gendereng,
                    },
                });
            }
            
            this.genderMultiselectArray[0].options = tempArray;
        });
    },
    
    addUsers(){
      // let isNameValid = this.$helper.checkString(this.userDataVModels.name);
      // let isEngNameValid = this.$helper.checkEngString(this.userDataVModels.nameeng);
      // let isSurnameValid = this.$helper.checkString(this.userDataVModels.surename);
      // let isSurnameEngValid = this.$helper.checkEngString(this.userDataVModels.surenameeng);
      // let isPersonal_numberValid = this.$helper.checkPersonalNumber(this.userDataVModels.personal_number);
      // let isEmailValid = this.$helper.checkEmail(this.userDataVModels.email);
      // let isDateValid = this.$helper.checkDateWithRegex(this.userDataVModels.bdate);
      // let isGenderIdValid = this.$helper.checkNumber(this.userDataVModels.genderID);
      // let isofficeIDValid = this.$helper.checkNumber(this.userDataVModels.officeID);
      // let ispositionIDValid = this.$helper.checkNumber(this.userDataVModels.positionID);
      // let isdistrictIDValid = this.$helper.checkNumber(this.userDataVModels.districtID);
      // let isAddressValid = this.$helper.checkJustString(this.userDataVModels.address);
      // let isPhoneValid = this.$helper.checkJustString(this.userDataVModels.phone);
      let isPhotoValid = this.$helper.checkJpeg(this.$refs.employeePhoto?.files[0]);

      // console.log(isNameValid);
      // console.log(isEngNameValid);
      // console.log(isSurnameValid);
      // console.log(isSurnameEngValid);
      // console.log(isPersonal_numberValid);
      // console.log(isEmailValid);
      // console.log(isDateValid);
      // console.log(isGenderIdValid);
      // console.log(isofficeIDValid);
      // console.log(ispositionIDValid);
      // console.log(isdistrictIDValid);
      // console.log(isAddressValid);
      // console.log(isPhoneValid);
      // console.log(isPhotoValid);

      if(this.userDataVModels.name && this.userDataVModels.nameeng && this.userDataVModels.surename && this.userDataVModels.surenameeng && this.userDataVModels.personal_number 
        && this.userDataVModels.email && this.userDataVModels.bdate && (this.userDataVModels.genderID || this.userDataVModels.genderID == 0) && this.userDataVModels.officeID && this.userDataVModels.positionID && this.userDataVModels.districtID 
        && this.userDataVModels.address && this.userDataVModels.phone && isPhotoValid){
          
        this.isSending = true;
        const formData = new FormData();
        for(let key of Object.keys(this.userDataVModels)){
          if(key == "phone"){
            formData.append(key, this.userDataVModels[key]);
          }else if(key == "photo"){
            formData.append('photo', this.$refs.employeePhoto?.files[0]);
          }
          else{
            formData.append(key, this.userDataVModels[key]);
          }
        }
        
        // for(let entries of formData.entries()){
        //   console.log(entries);
        // }
        this.$store.dispatch("addUsers", formData).then((response) => {
          if(response.status == 201){
            
            this.createdUserData.username = response.data.credentials[0];
            this.createdUserData.password = response.data.credentials[1];
            this.$helper.showSwal("თანამშრომელი წარმატებით დაემატა", "success", "");
          }
        }).catch((error) => {
          if(error?.response?.status == 422){
            
            this.$helper.showSwal("მოხდა შეცდომა", "error", "");
          }
        }).finally(() => {
          this.isSending = false;
        })
      }
    }
  }
}
</script>
<style scoped>
input[type="checkbox"]{
    width: 30px;
    height: 30px;
    cursor: pointer;
}
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(1, min-content);
  row-gap: 1.5em;
}
.add-organization-form{
  background-color: var(--secondary-background-color);
  width: 60%;
}
.modal-form-grid-wrapper{
  /* width: 100%; */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1em;
  row-gap: 2em;
}
.modal-form-grid-wrapper .blue-part-input{
  padding-block: 15px;
  max-width: 400px;
}
.button-wrapper, .multiselects-wrapper{
  grid-column: 1/3;
}
textarea.blue-part-input{
  width: 100%;
  resize: none;
}
.created-use-board{
    background-color: var(--creamColor);
    padding: 20px;
    border: 2px solid var(--light-blue);
}

@media screen and (max-width: 1800px) {
  .add-organization-form{
    width: 70%;
  }
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 2em;
  }
}

@media screen and (max-width: 1560px) {
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 2em;
  }
  .modal-form-grid-wrapper .blue-part-input{
    padding: 10px;
  }
}
@media screen and (max-width: 1200px) {
  .add-organization-form{
    width: 90%;
  }
}
</style>
